import { useEffect, useRef } from "react";

export default function useKeyPress(targetKeys, onKeyPress, enabled = true, targetRef = null) {
  const keyPressedRef = useRef(false);

  useEffect(() => {
    if (!enabled) return;

    const keysMatch = (event) => {
      const required = {
        Control: targetKeys.includes("Control"),
        Shift: targetKeys.includes("Shift"),
        Alt: targetKeys.includes("Alt"),
        Meta: targetKeys.includes("Meta"),
      };
      if (required.Control !== event.ctrlKey) return false;
      if (required.Shift !== event.shiftKey) return false;
      if (required.Alt !== event.altKey) return false;
      if (required.Meta !== event.metaKey) return false;

      // Find the non-modifier key in targetKeys
      const nonModifier = targetKeys.find((k) => !["Control", "Shift", "Alt", "Meta"].includes(k));
      if (nonModifier) {
        return event.key.toLowerCase() === nonModifier.toLowerCase();
      }
      // Only modifiers
      return true;
    };

    const downHandler = (event) => {
      if (event.repeat) return;
      if (keysMatch(event)) {
        keyPressedRef.current = true;
        if (onKeyPress) onKeyPress(false, event);
      }
    };

    const upHandler = (event) => {
      if (keysMatch(event)) {
        keyPressedRef.current = false;
        if (onKeyPress) onKeyPress(true, event);
      }
    };
    const target = targetRef?.current || window;
    target.addEventListener("keydown", downHandler);
    target.addEventListener("keyup", upHandler);

    return () => {
      target.removeEventListener("keydown", downHandler);
      target.removeEventListener("keyup", upHandler);
    };
  }, [targetKeys, targetRef, onKeyPress, enabled]);
  return keyPressedRef;
}
